import moment from 'moment';
import { WEBSITE_URL } from '../constants/APIConstants';
import ky from './kyextended';



const getReports = ({webId, page, page_size}) => {

    const searchParams = new URLSearchParams();
    searchParams.set('page', page);
    searchParams.set('page_size', page_size);

    return ky.get(`${WEBSITE_URL}${webId}/campaigns/reports/`, {
        searchParams: searchParams,
        headers: {
            Authorization: `Token ${localStorage.getItem('token')}`,
        }
    }).json();
    
} 

const getReportsByDate = ({webId, start_date, end_date}) => ky.post(`${WEBSITE_URL}${webId}/campaigns/reports/`, {
    json: {
        start_date: moment((start_date)).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        end_date: moment(end_date).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    },
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();



const getScheduledCampaigns = (webId) => ky.get(`${WEBSITE_URL}${webId}/campaigns/scheduled/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const createCampaigns = (webId, formData) => ky.post(`${WEBSITE_URL}${webId}/campaigns/`, {
    body: formData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const createCampaignsWithMultiWebsites = (formData) => ky.post(`${WEBSITE_URL}campaigns/`, {
    body: formData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const deleteScheduledCampaigns = (webId, ids) => ky.delete(`${WEBSITE_URL}${webId}/campaigns/scheduled/`, {
    json: ids,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const getCsvReport = (webId, {start_date, end_date}) => ky.post(`${WEBSITE_URL}${webId}/campaigns/reports/csv/`, {
    json: {
        start_date: moment((start_date)).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        end_date: moment(end_date).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    },
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).blob();

const getCampaignById = ({webId, id}) => ky.get(`${WEBSITE_URL}${webId}/campaigns/${id}/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export { 
    getReports, 
    getReportsByDate, 
    getScheduledCampaigns, 
    createCampaigns,
    deleteScheduledCampaigns,
    getCsvReport,
    createCampaignsWithMultiWebsites,
    getCampaignById
};